module.exports = __webpack_public_path__ + "img/font-zoom-out.719541f3.svg";